export interface AnimeItem {
  id: number;
  title: string;
  originalTitle: string;
  category: string;
  categorySlug: string;
  coverImage: string;
  rating: number;
  episodeCount: string;
  status: string;
  description: string;
  tags: string[];
  releaseDate: string;
  studio: string;
  director: string;
  views: string;
  isHot: boolean;
  isNew: boolean;
}

export const animeCategories = [
  { name: "日漫", slug: "japanese", icon: "ri-sun-line" },
  { name: "韩漫", slug: "korean", icon: "ri-moon-line" },
  { name: "国漫", slug: "chinese", icon: "ri-flag-2-line" },
  { name: "剧场版", slug: "movie", icon: "ri-film-line" },
];

export const allAnime: AnimeItem[] = [
  {
    id: 1,
    title: "鬼灭之刃 柱训练篇",
    originalTitle: "鬼滅の刃 柱稽古編",
    category: "日漫",
    categorySlug: "japanese",
    coverImage: "https://readdy.ai/api/search-image?query=Anime%20demon%20slayer%20style%20cover%20art%20with%20Japanese%20swordsman%20character%20in%20dark%20kimono%2C%20dramatic%20lighting%2C%20flame%20effects%2C%20dark%20background%20with%20red%20accents%2C%20clean%20illustration%20style%2C%20professional%20anime%20poster%20design&width=600&height=840&seq=anime-cover-01&orientation=portrait",
    rating: 9.7,
    episodeCount: "全8集",
    status: "已完结",
    description: "故事来到了新的舞台——继无限城之战后，炭治郎等人为了变得更强，接受了柱们严格的训练。水柱、虫柱、音柱、霞柱、恋柱、蛇柱、风柱、岩柱，每位柱都以各自独特的方式对年轻剑士们进行特训。在严酷的训练中，炭治郎不仅提升了剑术，更领悟到了作为剑士的真正意义。与此同时，无惨的阴影正悄然逼近……",
    tags: ["热血", "战斗", "奇幻", "历史"],
    releaseDate: "2024-05-12",
    studio: "ufotable",
    director: "外崎春雄",
    views: "1250万",
    isHot: true,
    isNew: false,
  },
  {
    id: 2,
    title: "咒术回战 第二季",
    originalTitle: "呪術廻戦 第2期",
    category: "日漫",
    categorySlug: "japanese",
    coverImage: "https://readdy.ai/api/search-image?query=Jujutsu%20Kaisen%20style%20anime%20poster%20with%20white%20haired%20character%20wearing%20blindfold%2C%20dynamic%20action%20pose%2C%20purple%20and%20blue%20energy%20effects%2C%20dark%20urban%20background%2C%20clean%20minimal%20illustration&width=600&height=840&seq=anime-cover-02&orientation=portrait",
    rating: 9.5,
    episodeCount: "全23集",
    status: "已完结",
    description: "最强的两人，回不去的青春。五条悟和夏油杰在高专时代的往事被揭开——曾是挚友的二人，如何走向截然不同的命运。而在现代时间线中，涉谷事变爆发，咒术界面临前所未有的危机。虎杖悠仁、伏黑惠、钉崎野蔷薇等年轻咒术师们，将在这场浩劫中经历生死考验。",
    tags: ["战斗", "奇幻", "校园", "暗黑"],
    releaseDate: "2023-07-06",
    studio: "MAPPA",
    director: "御所园翔太",
    views: "2100万",
    isHot: true,
    isNew: false,
  },
  {
    id: 3,
    title: "葬送的芙莉莲",
    originalTitle: "葬送のフリーレン",
    category: "日漫",
    categorySlug: "japanese",
    coverImage: "https://readdy.ai/api/search-image?query=Frieren%20anime%20style%20cover%20art%2C%20elf%20mage%20with%20silver%20hair%20holding%20staff%2C%20peaceful%20meadow%20background%20with%20soft%20sunlight%2C%20gentle%20fantasy%20atmosphere%2C%20minimal%20and%20elegant%20illustration&width=600&height=840&seq=anime-cover-03&orientation=portrait",
    rating: 9.8,
    episodeCount: "全28集",
    status: "已完结",
    description: "打倒魔王的勇者一行人「之后」的故事。魔法使芙莉莲身为精灵，拥有远超人类的寿命。在勇者辛美尔逝去后，她才意识到自己对他的了解少之又少。带着这份遗憾，芙莉莲踏上了「了解人类」的旅程。旅途中，她邂逅了新伙伴，也重新走过了与勇者一行曾经走过的路。",
    tags: ["奇幻", "冒险", "治愈", "成长"],
    releaseDate: "2023-09-29",
    studio: "MADHOUSE",
    director: "斋藤圭一郎",
    views: "1800万",
    isHot: true,
    isNew: false,
  },
  {
    id: 4,
    title: "我独自升级",
    originalTitle: "나 혼자만 레벨업",
    category: "韩漫",
    categorySlug: "korean",
    coverImage: "https://readdy.ai/api/search-image?query=Solo%20Leveling%20style%20anime%20poster%2C%20dark%20haired%20hunter%20with%20purple%20glowing%20eyes%2C%20black%20armor%2C%20shadow%20army%20behind%20him%2C%20dramatic%20dark%20background%2C%20powerful%20and%20cool%20illustration&width=600&height=840&seq=anime-cover-04&orientation=portrait",
    rating: 9.3,
    episodeCount: "全12集",
    status: "已完结",
    description: "在被称为「门」的异次元空间出现后，世界诞生了拥有特殊能力的「猎人」。成振宇是被称为「人类最弱兵器」的E级猎人。在一次几乎全员覆灭的「双重地下城」任务中，他奇迹般地活了下来，并获得了神秘的「系统」能力——他成为了唯一能够「升级」的猎人。从最弱到最强，成振宇的崛起之路正式开始！",
    tags: ["战斗", "奇幻", "系统", "升级"],
    releaseDate: "2024-01-07",
    studio: "A-1 Pictures",
    director: "中重俊祐",
    views: "3200万",
    isHot: true,
    isNew: true,
  },
  {
    id: 5,
    title: "完美世界",
    originalTitle: "完美世界",
    category: "国漫",
    categorySlug: "chinese",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20donghua%20style%20cover%2C%20young%20cultivator%20with%20long%20black%20hair%20in%20flowing%20white%20robe%2C%20mystical%20ancient%20Chinese%20palace%20background%2C%20celestial%20atmosphere%2C%20elegant%20fantasy%20illustration&width=600&height=840&seq=anime-cover-05&orientation=portrait",
    rating: 9.2,
    episodeCount: "更新至182集",
    status: "连载中",
    description: "一粒尘可填海，一株草可斩星辰。石昊出生在下界荒域，天生至尊却被夺走至尊骨，危在旦夕。在父母拼死保护下，他被送到石村抚养。少年石昊凭借坚毅不拔的意志，一步步踏上修炼之路，从大荒中走出，一路披荆斩棘，誓要重回至尊之位，探寻身世之谜。",
    tags: ["玄幻", "修仙", "热血", "冒险"],
    releaseDate: "2021-04-23",
    studio: "福煦影视",
    director: "汪成果",
    views: "5600万",
    isHot: true,
    isNew: false,
  },
  {
    id: 6,
    title: "斗破苍穹 年番",
    originalTitle: "斗破苍穹",
    category: "国漫",
    categorySlug: "chinese",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20donghua%20battle%20through%20the%20heavens%20style%2C%20young%20warrior%20with%20black%20robes%20holding%20giant%20ruler%20weapon%2C%20flame%20effects%2C%20epic%20fantasy%20landscape%20background%2C%20powerful%20dynamic%20illustration&width=600&height=840&seq=anime-cover-06&orientation=portrait",
    rating: 9.1,
    episodeCount: "更新至126集",
    status: "连载中",
    description: "天才少年萧炎创造了家族空前绝后的修炼纪录，却在一夜之间沦为废人。种种打击接踵而至，曾经的天才变得一无所有。就在他即将绝望之时，一缕灵魂从他手上的戒指里浮现——药老的出现，让萧炎重新燃起了希望。在药老的指导下，萧炎踏上了重回巅峰的征途。",
    tags: ["玄幻", "热血", "冒险", "成长"],
    releaseDate: "2022-07-31",
    studio: "幻维数码",
    director: "沈乐平",
    views: "4800万",
    isHot: true,
    isNew: false,
  },
  {
    id: 7,
    title: "铃芽之旅",
    originalTitle: "すずめの戸締まり",
    category: "剧场版",
    categorySlug: "movie",
    coverImage: "https://readdy.ai/api/search-image?query=Suzume%20anime%20movie%20poster%20style%2C%20young%20girl%20with%20backpack%20standing%20before%20mysterious%20door%20in%20abandoned%20ruins%2C%20beautiful%20sky%20with%20soft%20clouds%2C%20water%20reflection%2C%20Makoto%20Shinkai%20style%20cinematic%20illustration&width=600&height=840&seq=anime-cover-07&orientation=portrait",
    rating: 9.0,
    episodeCount: "剧场版",
    status: "已完结",
    description: "生活在九州乡下的17岁少女铃芽，遇到了一名为了寻找「门」而踏上旅途的青年。追随着青年的脚步，铃芽在山中废墟中发现了一扇古老的门。仿佛是某种指引一般，铃芽将手伸向了那扇门——「门」的另一端，似乎连接着所有时间。不久后，日本各地开始出现一扇扇打开的门。为了关上灾祸之源，铃芽踏上了关门之旅。",
    tags: ["奇幻", "冒险", "治愈", "爱情"],
    releaseDate: "2022-11-11",
    studio: "CoMix Wave Films",
    director: "新海诚",
    views: "890万",
    isHot: false,
    isNew: true,
  },
  {
    id: 8,
    title: "间谍过家家 第二季",
    originalTitle: "SPY×FAMILY Season 2",
    category: "日漫",
    categorySlug: "japanese",
    coverImage: "https://readdy.ai/api/search-image?query=Spy%20x%20Family%20anime%20poster%20style%2C%20family%20of%20three%20including%20man%20in%20suit%2C%20woman%20with%20red%20hair%2C%20and%20pink%20haired%20little%20girl%20with%20dog%2C%20warm%20and%20playful%20atmosphere%2C%20clean%20illustration&width=600&height=840&seq=anime-cover-08&orientation=portrait",
    rating: 9.4,
    episodeCount: "全12集",
    status: "已完结",
    description: "为了执行任务，西国间谍「黄昏」被迫组建临时家庭。他的「女儿」是会读心的超能力者阿尼亚，「妻子」是暗杀者约尔。三人互相隐藏着真实身份，却在一起生活中渐渐产生了真正的羁绊。第二季中，福杰一家将面临更多挑战，而阿尼亚的校园生活也迎来了新的篇章。",
    tags: ["喜剧", "日常", "间谍", "家庭"],
    releaseDate: "2023-10-07",
    studio: "WIT STUDIO / CloverWorks",
    director: "古桥一浩",
    views: "1600万",
    isHot: false,
    isNew: false,
  },
  {
    id: 9,
    title: "神之塔 第二季",
    originalTitle: "신의 탑 2기",
    category: "韩漫",
    categorySlug: "korean",
    coverImage: "https://readdy.ai/api/search-image?query=Tower%20of%20God%20anime%20style%2C%20mysterious%20tall%20tower%20reaching%20sky%2C%20young%20characters%20climbing%2C%20fantasy%20world%20vibrant%20colors%2C%20adventure%20atmosphere%2C%20clean%20Korean%20webtoon%20style&width=600&height=840&seq=anime-cover-09&orientation=portrait",
    rating: 8.8,
    episodeCount: "全13集",
    status: "已完结",
    description: "只要登顶神之塔，就能获得任何想要的东西——财富、权力、荣耀，甚至成为神。少女蕾哈尔为了看星星而进入塔中，少年二十五夜为了追随她紧随其后。在塔中，每一层都是一场试炼，只有通过试炼的人才能继续攀登。友情、背叛、阴谋，一切都在塔中交织。",
    tags: ["奇幻", "冒险", "战斗", "悬疑"],
    releaseDate: "2024-07-07",
    studio: "Answer Studio",
    director: "铃木慧",
    views: "670万",
    isHot: false,
    isNew: true,
  },
  {
    id: 10,
    title: "凡人修仙传",
    originalTitle: "凡人修仙传",
    category: "国漫",
    categorySlug: "chinese",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20donghua%20immortal%20cultivation%20poster%2C%20ordinary%20looking%20young%20man%20in%20simple%20blue%20robe%20holding%20flying%20sword%2C%20ancient%20Chinese%20mountain%20landscape%20with%20mist%2C%20minimal%20elegant%20style&width=600&height=840&seq=anime-cover-10&orientation=portrait",
    rating: 9.3,
    episodeCount: "更新至98集",
    status: "连载中",
    description: "韩立出身贫寒，为了家人能过上更好的生活，他踏上了修仙之路。没有逆天天赋，没有绝世功法，有的只是一颗永不言弃的道心。在天南大陆的修真界中，韩立凭借智谋与谨慎，一步步从最底层散修成长为威震一方的大修士。",
    tags: ["修仙", "冒险", "智谋", "成长"],
    releaseDate: "2020-07-25",
    studio: "原力动画",
    director: "王裕仁",
    views: "3500万",
    isHot: false,
    isNew: false,
  },
  {
    id: 11,
    title: "你想活出怎样的人生",
    originalTitle: "君たちはどう生きるか",
    category: "剧场版",
    categorySlug: "movie",
    coverImage: "https://readdy.ai/api/search-image?query=The%20Boy%20and%20the%20Heron%20Studio%20Ghibli%20style%2C%20young%20boy%20with%20mysterious%20grey%20heron%2C%20dreamlike%20fantasy%20world%20with%20soft%20watercolor%20texture%2C%20whimsical%20and%20melancholic%20atmosphere&width=600&height=840&seq=anime-cover-11&orientation=portrait",
    rating: 8.9,
    episodeCount: "剧场版",
    status: "已完结",
    description: "宫崎骏导演的最新力作。少年牧真人在母亲去世后，随父亲搬到乡下生活。在那里，他遇到了一只会说话的苍鹭，被引导进入了一个神秘的世界。在这个奇幻世界中，真人经历了一系列不可思议的冒险，也逐渐理解了关于生命、死亡和成长的真正意义。",
    tags: ["奇幻", "冒险", "治愈", "成长"],
    releaseDate: "2023-07-14",
    studio: "吉卜力工作室",
    director: "宫崎骏",
    views: "750万",
    isHot: false,
    isNew: false,
  },
  {
    id: 12,
    title: "药屋少女的呢喃",
    originalTitle: "薬屋のひとりごと",
    category: "日漫",
    categorySlug: "japanese",
    coverImage: "https://readdy.ai/api/search-image?query=The%20Apothecary%20Diaries%20anime%20poster%2C%20beautiful%20girl%20with%20freckles%20and%20green%20hair%20in%20Chinese%20style%20palace%20dress%2C%20ancient%20imperial%20palace%20background%2C%20elegant%20soft%20colors&width=600&height=840&seq=anime-cover-12&orientation=portrait",
    rating: 9.6,
    episodeCount: "全24集",
    status: "已完结",
    description: "在花开后宫之中，有一位与众不同的少女——猫猫。她原本只是药屋的女儿，却因缘际会被卖入后宫当侍女。凭借着对药物和毒物的过人知识，猫猫开始在暗中解决后宫中的各种谜团和事件。而她独特的性格和才智，也引起了美貌宦官壬氏的注意……",
    tags: ["推理", "历史", "宫廷", "悬疑"],
    releaseDate: "2023-10-22",
    studio: "TOHO animation STUDIO / OLM",
    director: "长沼范裕",
    views: "950万",
    isHot: false,
    isNew: false,
  },
];

export const featuredAnime = allAnime.filter((a) => a.isHot).slice(0, 6);

export const latestUpdates = [...allAnime].sort((a, b) => new Date(b.releaseDate).getTime() - new Date(a.releaseDate).getTime()).slice(0, 8);

export function getAnimeByCategory(slug: string): AnimeItem[] {
  return allAnime.filter((a) => a.categorySlug === slug);
}

export function getAnimeById(id: number): AnimeItem | undefined {
  return allAnime.find((a) => a.id === id);
}

export function getRelatedAnime(currentId: number, categorySlug: string): AnimeItem[] {
  return allAnime.filter((a) => a.id !== currentId && a.categorySlug === categorySlug).slice(0, 4);
}

export interface FAQ {
  question: string;
  answer: string;
}

export const faqData: FAQ[] = [
  {
    question: "51动漫官网提供哪些类型的动漫资源？",
    answer: "51动漫官网提供丰富的动漫资源，涵盖日漫、韩漫、国漫以及剧场版动漫。无论是热播新番还是经典老番，在这里都能找到。我们持续更新动漫全集资源，满足不同用户的追更需求。",
  },
  {
    question: "如何在51动漫官网在线观看动漫？",
    answer: "在51动漫官网首页浏览或搜索您想看的动漫，点击进入详情页即可在线观看。我们提供流畅的播放体验和下拉式阅读模式，让您沉浸在动漫世界中。无需注册，完全免费。",
  },
  {
    question: "支持动漫下载吗？如何下载动漫？",
    answer: "是的，51动漫官网支持动漫下载功能。在动漫详情页中可以找到下载选项，支持多种清晰度选择。我们建议在Wi-Fi网络环境下进行下载，以获得最佳体验。",
  },
  {
    question: "51动漫官网的资源更新频率如何？",
    answer: "我们每天都会更新最新的动漫资源。日漫通常在播出后24小时内更新，国产动漫和韩漫也会在第一时间同步更新。您可以关注首页的「最新更新」板块获取最新上架的动漫。",
  },
  {
    question: "什么是下拉式阅读模式？",
    answer: "下拉式阅读是51动漫官网的特色功能之一。在阅读漫画内容时，您无需翻页，只需向下滑动即可连续阅读，带来类似短视频的沉浸式浏览体验。特别适合手机端用户追更漫画。",
  },
  {
    question: "51动漫官网需要付费吗？",
    answer: "不需要！51动漫官网始终坚持免费服务，所有动漫资源均可免费在线观看和下载。我们不向用户收取任何费用，致力于为广大动漫爱好者提供优质的免费动漫资源。",
  },
];

export const siteStats = [
  { label: "动漫资源", value: "10,000+", icon: "ri-movie-2-line" },
  { label: "日更新量", value: "50+", icon: "ri-refresh-line" },
  { label: "注册用户", value: "500万+", icon: "ri-user-3-line" },
  { label: "累计播放", value: "10亿+", icon: "ri-play-circle-line" },
];

export const testimonials = [
  {
    name: "动漫迷小张",
    avatar: "https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20avatar%20portrait%2C%20friendly%20smile%2C%20casual%20style%2C%20simple%20light%20gray%20background%2C%20clean%20professional%20headshot&width=120&height=120&seq=avatar-01&orientation=squarish",
    content: "用了51动漫两年了，资源全更新快，日漫国漫都能找到，真心推荐给所有动漫爱好者！",
    rating: 5,
  },
  {
    name: "追番少女",
    avatar: "https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20avatar%20portrait%2C%20warm%20smile%2C%20modern%20casual%20look%2C%20simple%20light%20gray%20background%2C%20clean%20professional%20headshot&width=120&height=120&seq=avatar-02&orientation=squarish",
    content: "下拉式阅读体验太棒了！追漫画不用一页页翻，体验感满分。每天必刷的动漫网站。",
    rating: 5,
  },
  {
    name: "老二次元",
    avatar: "https://readdy.ai/api/search-image?query=Middle%20aged%20Chinese%20man%20avatar%20portrait%2C%20gentle%20smile%2C%20glasses%2C%20simple%20light%20gray%20background%2C%20clean%20professional%20headshot&width=120&height=120&seq=avatar-03&orientation=squarish",
    content: "作为10年老宅，51动漫的分类和搜索做得很用心，找番方便，画质清晰，强烈安利！",
    rating: 5,
  },
];